import Vue from 'vue';
import PromoSaleShopsComponent from '~/components/home/mainpage-promosale-shops-component.vue';

DM.Module.PromoSaleShops = ((DM) => {
    const SELECTOR = '.js-main-promosale-shops';
    const ELEMENT = document.querySelector(SELECTOR);

    class PromoSaleShops {
        constructor(element) {
            const tabs = DM.Boot.MainPage.mainPageShopsCards;
            this.createComponent(element, tabs);
        }

        createComponent(element, tabs) {
            return new Vue({
                name: 'dm-promosale-shops',
                el: element,
                components: {
                    'dm-promosale-shops': PromoSaleShopsComponent
                },
                template: '<dm-promosale-shops :tabs="tabs" />',
                data: {
                    tabs: tabs,
                }
            });
        }
    }
    if (ELEMENT) {
        new PromoSaleShops(ELEMENT);
    }
})(window.DM);
